import deepCloneLodash from 'lodash.clonedeep';
import isEqualLodash from 'lodash.isequal';
import deepMergeLodash from 'lodash.merge';

import {IterableObject} from '../classes/iterable-object';

export function flip(obj) {
    return Object.entries(obj).reduce((newObj, [key, value]: [string, any]) => ({...newObj, [value]: key}), {});
}

export function iterable<T extends Object = {}, V = T[keyof T], K = Partial<{[P in keyof T]: V}>, Z = K[keyof K] | V>(object: K) {
    return new IterableObject<K, Z>(object) as IterableObject<K, Z> & {[P in keyof K]: Z};
}

export function isObject(value: any): boolean {
    return value !== null && typeof value === 'object';
}

export function compareObjects(obj1: any, obj2: any, ignore?: Array<RegExp>): boolean {
    function isIgnored(fullPath: string) {
        if (Array.isArray(ignore)) {
            return ignore.some(regexp => regexp.test(fullPath));
        } else {
            return false;
        }
    }

    function compare(parentKey: string, value1: any, value2: any) {
        if (isObject(value1) && isObject(value2)) {
            let keys1 = value1 ? Object.keys(value1) : [];
            let keys2 = value2 ? Object.keys(value2) : [];
            if (keys1.length !== keys2.length) {
                return false;
            } else {
                return keys1.every(key => {
                    let fullPath = `${parentKey}.${key}`;
                    if (isIgnored(fullPath)) {
                        return true;
                    } else {
                        return compare(fullPath, value1[key], value2[key]);
                    }
                });
            }
        } else {
            return value1 === value2;
        }
    }

    return compare('', obj1, obj2);
}

export function cloneDeep<T>(value: T): T {
    return <T>deepCloneLodash(value);
}

export function mergeDeep<T>(source: T, other: Partial<T> | any): T {
    return <T>deepMergeLodash(source, other);
}

export function isEqualDeep(a, b): boolean {
    return isEqualLodash(a, b);
}

export function cloneObject<T extends Object>(source: T): T {
    return Object.create(Object.getPrototypeOf(source), Object.getOwnPropertyDescriptors(source));
}

export function move<T>(arr: T[], from: number, to: number): T[] {
    const el = arr[from];
    arr.splice(from, 1);
    arr.splice(to, 0, el);
    return arr;
}

export function swap<T>(arr: T[], from: number, to: number): T[] {
    const tmp = arr[from];
    arr[from] = arr[to];
    arr[to] = tmp;
    return arr;
}
